import SimIcon from './component'

export default SimIcon
